import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

const TONES = {
  completed: 'bg-success bg-opacity-10 text-success',
  processing: 'bg-orange-500 bg-opacity-10 text-orange-500',
  failed: 'bg-danger bg-opacity-10 text-danger'
}

const ICONS = {
  completed: UIcons.UilCheckCircle,
  processing: UIcons.UilClockThree,
  failed: UIcons.UilExclamationTriangle
}

export default withTranslation()(function ReportStatusTag({ t, status }) {
  const key = (status ?? '').toLowerCase()
  const Icon = ICONS[key]

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium whitespace-nowrap ${TONES[key] || TONES.completed}`}>
      {Icon && <Icon size={12} />} {t(`reports.status.${key}`, status || '--')}
    </span>
  )
})
